import { render } from "./DictionaryItems.vue?vue&type=template&id=717924e0&scoped=true"
import script from "./DictionaryItems.vue?vue&type=script&lang=js"
export * from "./DictionaryItems.vue?vue&type=script&lang=js"

import "./DictionaryItems.vue?vue&type=style&index=0&id=717924e0&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717924e0"]])

export default __exports__